const DUTCH_MONTHS = [
  'jan', 'feb', 'mrt', 'apr', 'mei', 'jun',
  'jul', 'aug', 'sep', 'okt', 'nov', 'dec',
];

export function formatDate(dateStr: string | false): string {
  if (!dateStr) return '';
  const [year, month, day] = dateStr.split('-');
  const monthIndex = parseInt(month, 10) - 1;
  if (monthIndex < 0 || monthIndex > 11) return dateStr;
  return `${parseInt(day, 10)} ${DUTCH_MONTHS[monthIndex]} ${year}`;
}

/**
 * Normalize a raw `project.project.name` for display.
 *
 * Strips the Sjabloon template suffix (" - S<nr> - …") FIRST when requested,
 * THEN replaces any literal "/" with " - ". Order matters: sanitizing the
 * slash first would insert a " - " that the suffix regex could then mistake
 * for a template tail (e.g. "CO123/4 Project" -> "CO123"). The slash is an S3
 * path separator; three SO-less projects carry it and it would otherwise
 * render raw on planning screens (and break photo lookups — see
 * resolveProjectName on the API side).
 */
export function displayProjectName(
  rawName: string,
  opts?: { stripTemplateSuffix?: boolean },
): string {
  let name = rawName;
  if (opts?.stripTemplateSuffix) name = name.replace(/\s*-\s*S?\d.*$/, '');
  return name.replace(/\//g, ' - ');
}
